import { websiteEnv } from '@/constants/website-env';
import { cn } from '@/lib/utils';
import CurrencySymbol from '@/util/currency';
import Image from 'next/image';
import type { ProductRoot } from '../types/product';

export const SezzleInfo = ({ product, className }: { product: ProductRoot; className?: string }) => {
  const sezzlePrice = Math.floor((product.price.regularPrice.amount.value / 4) * 100) / 100;

  return (
    <p className={cn('mt-2.5 lg_mt-0', className)}>
      <span className='text-sm leading-5'>
        <span>Or 4 interest-free payments of</span>
        <span className='ml-1.5'>
          {CurrencySymbol[product.price.regularPrice.amount.currency as keyof typeof CurrencySymbol]}
          {sezzlePrice}
        </span>
        <span>&nbsp;with</span>
      </span>
      {websiteEnv.isUnitedStates || websiteEnv.isCanada ? (
        <Image
          src={`${process.env.NEXT_PUBLIC_BASE_PATH}/Sezzle_Logo_FullColor.svg`}
          alt='sezzle'
          width={84}
          height={21}
          className=' ml-2.5 inline h-auto w-[72px]  '
        />
      ) : null}
      {websiteEnv.isUnitedStates || websiteEnv.isCanada ? (
        <>
          &nbsp;<span>or</span>
        </>
      ) : null}
      {websiteEnv.isUnitedStates ||
      websiteEnv.isCanada ||
      websiteEnv.isGermanyEnglish ||
      websiteEnv.isUnitedKingdom ||
      websiteEnv.isIreland ? (
        <>
          &nbsp;
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='44.98'
            height='18.93'
            fill='none'
            viewBox='0 0 1448 609'
            className='ml-1 inline-block h-auto w-11 lg_w-[55px]'
          >
            <path
              fill='#FFA8CD'
              d='M0 304.493C0 180.585 0 118.631 30.4 74.508A172.2 172.2 0 0 1 74.508 30.4C118.63 0 180.585 0 304.493 0h838.257c123.9 0 185.86 0 229.98 30.4a172.1 172.1 0 0 1 44.11 44.108c30.4 44.123 30.4 106.077 30.4 229.985s0 185.863-30.4 229.986a172.1 172.1 0 0 1-44.11 44.108c-44.12 30.4-106.08 30.4-229.98 30.4H304.494c-123.909 0-185.863 0-229.986-30.4A172.2 172.2 0 0 1 30.4 534.479C0 490.356 0 428.402 0 304.493'
            ></path>
            <path
              fill='#0B051D'
              d='M1166.17 389.005c-25.25 0-44.93-20.88-44.93-46.234s19.68-46.235 44.93-46.235 44.93 20.88 44.93 46.235c0 25.354-19.68 46.234-44.93 46.234m-12.63 48.845c21.54 0 49.02-8.203 64.25-40.269l1.48.746c-6.68 17.524-6.68 27.965-6.68 30.575v4.101h54.21V252.538h-54.21v4.102c0 2.61 0 13.05 6.68 30.574l-1.48.746c-15.23-32.066-42.71-40.269-64.25-40.269-51.61 0-88 41.015-88 95.08s36.39 95.079 88 95.079M971.216 247.691c-24.509 0-43.819 8.576-59.415 40.269l-1.485-.746C917 269.69 917 259.25 917 256.64v-4.102h-54.216v180.465h55.701v-95.08c0-24.981 14.483-40.642 37.877-40.642s34.906 13.423 34.906 40.269v95.453h55.702V318.162c0-41.015-31.94-70.471-75.754-70.471M782.203 287.96l-1.486-.746c6.684-17.524 6.684-27.964 6.684-30.574v-4.102h-54.215v180.465h55.701l.371-86.877c0-25.354 13.368-40.642 35.278-40.642 5.941 0 10.769.746 16.339 2.238v-55.184c-24.509-5.22-46.418 4.102-58.672 35.422m-177.13 101.045c-25.252 0-44.933-20.88-44.933-46.234s19.681-46.235 44.933-46.235 44.932 20.88 44.932 46.235c0 25.354-19.681 46.234-44.932 46.234m-12.626 48.845c21.538 0 49.017-8.203 64.242-40.269l1.485.746c-6.684 17.524-6.684 27.965-6.684 30.575v4.101h54.216V252.538H651.49v4.102c0 2.61 0 13.05 6.684 30.574l-1.485.746c-15.225-32.066-42.704-40.269-64.242-40.269-51.617 0-88.008 41.015-88.008 95.08s36.391 95.079 88.008 95.079m-165.619-4.847h55.702V172h-55.702zM385.981 172h-56.816c0 46.608-28.593 88.368-72.04 118.197l-17.082 11.932V172H181v261.003h59.043V303.62l97.663 129.383h72.041l-93.95-123.79c42.704-30.947 70.555-79.047 70.184-137.213'
            ></path>
          </svg>
        </>
      ) : null}
    </p>
  );
};
